import { AuthState } from '@okta/okta-auth-js';

import { CompuweighMassUpdates } from '../../services/backend/CompuweighMassUpdates';
import { useBaseApiClient } from '../useBaseApiClient';

export const useCompuweighMassUpdates: () => CompuweighMassUpdates<AuthState> = () => {
  return useBaseApiClient(CompuweighMassUpdates);
};
